// Scroll animations
document.addEventListener('DOMContentLoaded', function () {
  const sections = document.querySelectorAll('.shopify-section:not(.shopify-section-main)');

  sections.forEach(function (section) {
    section.classList.add('scroll-animate');
  });

  const observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0, rootMargin: '0px 0px -10% 0px' });

  sections.forEach(function (section) {
    observer.observe(section);
  });
});

// Sticky Add to Cart flotante
document.addEventListener('DOMContentLoaded', function () {
  if (!window.location.pathname.includes('/products/')) return;
  const addToCartBtn = document.querySelector('form[action="/cart/add"] button[type="submit"]');
  if (!addToCartBtn) return;

  const isMobile = window.innerWidth <= 749;

  function getProductTitle() {
    const scope = document.querySelector('[class*="product-details"], [id*="product-details"]') || document;
    const heading = scope.querySelector('h1, h2, h3');
    if (heading && heading.innerText.trim()) return heading.innerText.trim();
    return (document.title || '').split(/[\|\u2013\u2014]/)[0].trim();
  }

  const productTitle = getProductTitle();
  const productImg = document.querySelector('.product__media img, .product-media-container img, .product__photo img')?.src || '';

  const salePrice = document.querySelector('.price--sale .price-item--sale, .price__sale .price-item--sale')?.innerText || '';
  const regularPrice = document.querySelector('.price--sale .price-item--regular, .price__sale .price-item--regular')?.innerText || '';
  const currentPrice = document.querySelector('.price-item--regular, .price__regular .price-item')?.innerText || '';

  const priceHTML = salePrice
    ? `<span id="sticky-atc-sale">${salePrice}</span><span id="sticky-atc-regular">${regularPrice}</span>`
    : `<span id="sticky-atc-sale">${currentPrice}</span>`;

  const buttonContent = isMobile
    ? `<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24">
        <path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/>
        <line x1="3" y1="6" x2="21" y2="6"/>
        <path d="M16 10a4 4 0 0 1-8 0"/>
      </svg>`
    : `Add to Cart`;

  const bar = document.createElement('div');
  bar.id = 'sticky-atc-bar';
  bar.innerHTML = `
    <div id="sticky-atc-inner">
      ${productImg ? `<img id="sticky-atc-img" src="${productImg}" alt="${productTitle}">` : ''}
      <div id="sticky-atc-info">
        <span id="sticky-atc-title">${productTitle}</span>
        <div id="sticky-atc-prices">${priceHTML}</div>
      </div>
      <button id="sticky-atc-btn">${buttonContent}</button>
    </div>
  `;
  document.body.appendChild(bar);

  const stickyBtn = document.getElementById('sticky-atc-btn');

  stickyBtn.addEventListener('click', function () {
    const form = document.querySelector('form[action="/cart/add"]');
    const variantId = form.querySelector('[name="id"]')?.value;
    if (!variantId) return;

    stickyBtn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(function(res) { return res.json(); })
    .then(function() {
      window.location.href = '/cart';
    })
    .catch(function() {
      stickyBtn.disabled = false;
      alert('No se pudo agregar al carrito. Intenta de nuevo.');
    });
  });

  const observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        bar.classList.remove('visible');
      } else {
        bar.classList.add('visible');
      }
    });
  }, { threshold: 0 });

  observer.observe(addToCartBtn);
});